export default "__VITE_ASSET__psjqFcX3__"